import AuthState from '@/models/auth/auth-state.model';
import UserLogin from '@/models/auth/user-login.model';
import { ActionTree } from "vuex";
import authService from "../../services/auth/auth-service"
import AuthUser from '@/models/auth/auth-user.model';
import RememberPassword from '@/models/auth/auth-remember-password.model';
import RecoveryPassword from '@/models/auth/auth-recovery-password.model';

export const actions: ActionTree<AuthState, {}> = {
    setUserLogin({ commit }, userLogin: UserLogin) {
        commit('setUserLogin', userLogin);
    },
    setRememberPassword({ commit }, property: RememberPassword) {
        commit('setRememberPassword', property);
    },
    setRecoveryPassword({ commit }, property: RecoveryPassword) {
        commit('setRecoveryPassword', property);
    },
    setIsLoading({ commit }, isLoading: boolean) {
        commit('setIsLoading', isLoading);
    },
    setIsSubmitted({ commit }, isSubmitted: boolean) {
        commit('setIsSubmitted', isSubmitted);
    },
    setIsErrorLogin({ commit }, isErrorLogin: boolean) {
        commit('setIsErrorLogin', isErrorLogin);
    },
    setIsErrorRequest({ commit }, isErrorRequest: boolean) {
        commit('setIsErrorRequest', isErrorRequest);
    },
    async login({ }, userLogin: AuthUser) {
        return await authService.login(userLogin);
    },
    async getToken({}, username: Object) {
        return await authService.getToken(username);
    },
    async rememberPassword({ }, rememberPassword: RememberPassword) {
        return await authService.rememberPassword(rememberPassword);
    },
    async recoveryPassword({ }, recoveryPassword: RecoveryPassword) {
        return await authService.recoveryPassword(recoveryPassword);
    }
};
